import {
  EC2Client,
  DescribeTrafficMirrorFiltersCommand,
  CreateTrafficMirrorFilterCommand,
  DeleteTrafficMirrorFilterCommand,
  ModifyTrafficMirrorFilterNetworkServicesCommand,
  CreateTrafficMirrorFilterRuleCommand,
  DeleteTrafficMirrorFilterRuleCommand,
  ModifyTrafficMirrorFilterRuleCommand,
} from "@aws-sdk/client-ec2";

const fields = [
  {
    variable: "Description",
    hidden: false,
    title: "Filter Description",
    field: "Description",
    defaultSort: "asc",
    type: "string",
  },
  {
    variable: "NetworkServices",
    hidden: false,
    title: "Network Service",
    field: "NetworkServices",
    defaultSort: "asc",
    type: "string",
  },
  {
    variable: "IngressFilterRules",
    hidden: false,
    title: "Inbound Rules",
    field: "IngressFilterRules",
    type: "array",
  },
  {
    variable: "EgressFilterRules",
    hidden: false,
    title: "Outbound Rules",
    field: "EgressFilterRules",
    type: "array",
  },
];

const Protocols = [
  { number: -1, keyword: "All Protocols" },
  { number: 0, keyword: "HOPOPT (0)" },
  { number: 1, keyword: "ICMP (1)" },
  { number: 2, keyword: "IGMP (2)" },
  { number: 3, keyword: "GGP (3)" },
  { number: 4, keyword: "IPv4 (4)" },
  { number: 5, keyword: "ST (5)" },
  { number: 6, keyword: "TCP (6)" },
  { number: 7, keyword: "CBT (7)" },
  { number: 8, keyword: "EGP (8)" },
  { number: 9, keyword: "IGP (9)" },
  { number: 10, keyword: "BBN-RCC-MON (10)" },
  { number: 11, keyword: "NVP-II (11)" },
  { number: 12, keyword: "PUP (12)" },
  { number: 13, keyword: "ARGUS (13)" },
  { number: 14, keyword: "EMCON (14)" },
  { number: 15, keyword: "XNET (15)" },
  { number: 16, keyword: "CHAOS (16)" },
  { number: 17, keyword: "UDP (17)" },
  { number: 18, keyword: "MUX (18)" },
  { number: 19, keyword: "DCN-MEAS (19)" },
  { number: 20, keyword: "HMP (20)" },
  { number: 21, keyword: "PRM (21)" },
  { number: 22, keyword: "XNS-IDP (22)" },
  { number: 23, keyword: "TRUNK-1 (23)" },
  { number: 24, keyword: "TRUNK-2 (24)" },
  { number: 25, keyword: "LEAF-1 (25)" },
  { number: 26, keyword: "LEAF-2 (26)" },
  { number: 27, keyword: "RDP (27)" },
  { number: 28, keyword: "IRTP (28)" },
  { number: 29, keyword: "ISO-TP4 (29)" },
  { number: 30, keyword: "NETBLT (30)" },
  { number: 31, keyword: "MFE-NSP (31)" },
  { number: 32, keyword: "MERIT-INP (32)" },
  { number: 33, keyword: "DCCP (33)" },
  { number: 34, keyword: "3PC (34)" },
  { number: 35, keyword: "IDPR (35)" },
  { number: 36, keyword: "XTP (36)" },
  { number: 37, keyword: "DDP (37)" },
  { number: 38, keyword: "IDPR-CMTP (38)" },
  { number: 39, keyword: "TP++ (39)" },
  { number: 40, keyword: "IL (40)" },
  { number: 41, keyword: "IPv6 (41)" },
  { number: 42, keyword: "SDRP (42)" },
  { number: 43, keyword: "IPv6-Route (43)" },
  { number: 44, keyword: "IPv6-Frag (44)" },
  { number: 45, keyword: "IDRP (45)" },
  { number: 46, keyword: "RSVP (46)" },
  { number: 47, keyword: "GRE (47)" },
  { number: 48, keyword: "DSR (48)" },
  { number: 49, keyword: "BNA (49)" },
  { number: 50, keyword: "ESP (50)" },
  { number: 51, keyword: "AH (51)" },
  { number: 52, keyword: "I-NLSP (52)" },
  { number: 53, keyword: "SWIPE (53)" },
  { number: 54, keyword: "NARP (54)" },
  { number: 55, keyword: "Min-IPv4 (55)" },
  { number: 56, keyword: "TLSP (56)" },
  { number: 57, keyword: "SKIP (57)" },
  { number: 58, keyword: "IPv6-ICMP (58)" },
  { number: 59, keyword: "IPv6-NoNxt (59)" },
  { number: 60, keyword: "IPv6-Opts (60)" },
  { number: 61, keyword: "" },
  { number: 62, keyword: "CFTP (62)" },
  { number: 63, keyword: "" },
  { number: 64, keyword: "SAT-EXPAK (64)" },
  { number: 65, keyword: "KRYPTOLAN (65)" },
  { number: 66, keyword: "RVD (66)" },
  { number: 67, keyword: "IPPC (67)" },
  { number: 68, keyword: "" },
  { number: 69, keyword: "SAT-MON (69)" },
  { number: 70, keyword: "VISA (70)" },
  { number: 71, keyword: "IPCV (71)" },
  { number: 72, keyword: "CPNX (72)" },
  { number: 73, keyword: "CPHB (73)" },
  { number: 74, keyword: "WSN (74)" },
  { number: 75, keyword: "PVP (75)" },
  { number: 76, keyword: "BR-SAT-MON (76)" },
  { number: 77, keyword: "SUN-ND (77)" },
  { number: 78, keyword: "WB-MON (78)" },
  { number: 79, keyword: "WB-EXPAK (79)" },
  { number: 80, keyword: "ISO-IP (80)" },
  { number: 81, keyword: "VMTP (81)" },
  { number: 82, keyword: "SECURE-VMTP (82)" },
  { number: 83, keyword: "VINES (83)" },
  { number: 84, keyword: "IPTM (84)" },
  { number: 85, keyword: "NSFNET-IGP (85)" },
  { number: 86, keyword: "DGP (86)" },
  { number: 87, keyword: "TCF (87)" },
  { number: 88, keyword: "EIGRP (88)" },
  { number: 89, keyword: "OSPFIGP (89)" },
  { number: 90, keyword: "Sprite-RPC (90)" },
  { number: 91, keyword: "LARP (91)" },
  { number: 92, keyword: "MTP (92)" },
  { number: 93, keyword: "AX.25 (93)" },
  { number: 94, keyword: "IPIP (94)" },
  { number: 95, keyword: "MICP (95)" },
  { number: 96, keyword: "SCC-SP (96)" },
  { number: 97, keyword: "ETHERIP (97)" },
  { number: 98, keyword: "ENCAP (98)" },
  { number: 99, keyword: "" },
  { number: 100, keyword: "GMTP (100)" },
  { number: 101, keyword: "IFMP (101)" },
  { number: 102, keyword: "PNNI (102)" },
  { number: 103, keyword: "PIM (103)" },
  { number: 104, keyword: "ARIS (104)" },
  { number: 105, keyword: "SCPS (105)" },
  { number: 106, keyword: "QNX (106)" },
  { number: 107, keyword: "A/N (107)" },
  { number: 108, keyword: "IPComp (108)" },
  { number: 109, keyword: "SNP (109)" },
  { number: 110, keyword: "Compaq-Peer (110)" },
  { number: 111, keyword: "IPX-in-IP (111)" },
  { number: 112, keyword: "VRRP (112)" },
  { number: 113, keyword: "PGM (113)" },
  { number: 114, keyword: "" },
  { number: 115, keyword: "L2TP (115)" },
  { number: 116, keyword: "DDX (116)" },
  { number: 117, keyword: "IATP (117)" },
  { number: 118, keyword: "STP (118)" },
  { number: 119, keyword: "SRP (119)" },
  { number: 120, keyword: "UTI (120)" },
  { number: 121, keyword: "SMP (121)" },
  { number: 122, keyword: "SM (122)" },
  { number: 123, keyword: "PTP (123)" },
  { number: 124, keyword: "ISIS over IPv4 (124)" },
  { number: 125, keyword: "FIRE (125)" },
  { number: 126, keyword: "CRTP (126)" },
  { number: 127, keyword: "CRUDP (127)" },
  { number: 128, keyword: "SSCOPMCE (128)" },
  { number: 129, keyword: "IPLT (129)" },
  { number: 130, keyword: "SPS (130)" },
  { number: 131, keyword: "PIPE (131)" },
  { number: 132, keyword: "SCTP (132)" },
  { number: 133, keyword: "FC (133)" },
  { number: 134, keyword: "RSVP-E2E-IGNORE (134)" },
  { number: 135, keyword: "Mobility Header (135)" },
  { number: 136, keyword: "UDPLite (136)" },
  { number: 137, keyword: "MPLS-in-IP (137)" },
  { number: 138, keyword: "manet (138)" },
  { number: 139, keyword: "HIP (139)" },
  { number: 140, keyword: "Shim6 (140)" },
  { number: 141, keyword: "WESP (141)" },
  { number: 142, keyword: "ROHC (142)" },
  { number: 143, keyword: "Ethernet (143)" },
  { number: 144, keyword: "AGGFRAG (144)" },
  { number: 145, keyword: "NSH (145)" },
];

class FilterService {
  constructor(config) {
    this.searchPlaceholder = "Search Mirror Filter";
    this.fields = fields;
    this.config = config;
    this.ec2Client = new EC2Client(this.config);
  }

  getFilters = async (query) => {
    let input = {};
    try {
      if (query) {
        input = { Filters: [{ Name: "description", Values: [query] }] };
      }

      const command = new DescribeTrafficMirrorFiltersCommand(input);
      const response = await this.ec2Client.send(command);

      return response.TrafficMirrorFilters;
    } catch (error) {
      console.error("Error fetching filters:", error);
      return error;
    }
  };

  getFilterById = async (filterId) => {
    let input = {};
    try {
      if (filterId) {
        input = { TrafficMirrorFilterIds: filterId, DryRun: false };
      }

      const command = new DescribeTrafficMirrorFiltersCommand(input);
      const response = await this.ec2Client.send(command);
      return response.TrafficMirrorFilters;
    } catch (error) {
      console.error("Error fetching filters by Id:", error);
      return error;
    }
  };
  createFilter = async (filter) => {
    let input = {};
    try {
      if (filter) {
        input = { Description: filter.Description, DryRun: false };
      }

      const command = new CreateTrafficMirrorFilterCommand(input);
      const response = await this.ec2Client.send(command);
      return response;
    } catch (error) {
      console.error("Error creating filters:", error);
      return error;
    }
  };
  deleteFilter = async (filterId) => {
    let input = {};
    try {
      if (filterId) {
        input = { TrafficMirrorFilterId: filterId, DryRun: false };
      }

      const command = new DeleteTrafficMirrorFilterCommand(input);
      const response = await this.ec2Client.send(command);
      return response;
    } catch (error) {
      console.error("Error deleteing filters:", error);
      return error;
    }
  };
  modifyFilter = async (filter, filterId) => {
    let input = {};
    try {
      if (filter.dns) {
        input = {
          TrafficMirrorFilterId: filterId,
          AddNetworkServices: ["amazon-dns"],
          DryRun: false,
        };
      } else {
        input = {
          TrafficMirrorFilterId: filterId,
          RemoveNetworkServices: ["amazon-dns"],
          DryRun: false,
        };
      }

      const command = new ModifyTrafficMirrorFilterNetworkServicesCommand(
        input
      );
      const response = await this.ec2Client.send(command);
      return response;
    } catch (error) {
      console.error("Error modifying filters:", error);
      return error;
    }
  };
  createFilterRule = async (filterRule) => {
    let input = {};
    try {
      if (filterRule) {
        input = { ...filterRule };
        delete input.TrafficMirrorFilterRuleId;
        if (input.Protocol === -1) {
          delete input.Protocol;
          delete input.SourcePortRange;
          delete input.DestinationPortRange;
        }
        if (input.Protocol !== 6 && input.Protocol !== 17) {
          delete input.SourcePortRange;
          delete input.DestinationPortRange;
        }
        if (input.Description === "") {
          delete input.Description;
        }
      }
      const command = new CreateTrafficMirrorFilterRuleCommand(input);
      const response = await this.ec2Client.send(command);
      return response;
    } catch (error) {
      console.error("Error creating filterrule:", error);
      return error;
    }
  };
  modifyFilterRule = async (filterRule) => {
    let input = {};
    try {
      if (filterRule) {
        input = { ...filterRule };

        if (input.Protocol === -1) {
          delete input.Protocol;
          delete input.SourcePortRange;
          delete input.DestinationPortRange;
        }
        if (input.Protocol !== 6 && input.Protocol !== 17) {
          delete input.SourcePortRange;
          delete input.DestinationPortRange;
        }

        if (input.Description === "") {
          delete input.Description;
        }
      }
      const command = new ModifyTrafficMirrorFilterRuleCommand(input);
      const response = await this.ec2Client.send(command);
      return response;
    } catch (error) {
      console.error("Error creating filterrule:", error);
      return error;
    }
  };
  deleteFilterRule = async (filterRuleId) => {
    let input = {};
    try {
      if (filterRuleId) {
        input = { TrafficMirrorFilterRuleId: filterRuleId, DryRun: false };
      }
      const command = new DeleteTrafficMirrorFilterRuleCommand(input);
      const response = await this.ec2Client.send(command);
      return response;
    } catch (error) {
      console.error("Error deleteing filterRule:", error);
      return error;
    }
  };
}

export {
  FilterService as default,
  fields as filterFields,
  Protocols as Protocols,
};
